import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Calendar } from "react-date-range";
import { gql } from "@apollo/client";
import dateFormat from "dateformat";
import { apolloClient } from "../../../index";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import ArrowDown from "../../../assets/icons/arrows/chevron-down.svg";
import ArrowUp from "../../../assets/icons/arrows/chevron-up.svg";
import CloseIcon from "../../../assets/icons/close.svg";
import { getIntials, getName } from "../../../helper";

const heading = ["Users", "Access"];

const isPopover = false;

class ShareWith extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shareUser: "",
      showDropDown: false,
      showDatePiker: false,
      selectedDate: null,
    };
    this.userSearchDropdownRef = React.createRef();
    this.handleClickOutsideOfUserSearch =
      this.handleClickOutsideOfUserSearch.bind(this);
  }
  componentDidMount() {
    if (this.props.totalCheck > 0) {
      const currentUser = this.props.currentUserInfo;
      this.props.multipleShare(currentUser);
    } else {
      const currentUser = this.props.currentUserInfo;
      const shareItem = this.props.shareFolder;
      const arrObj = !shareItem
        ? [
            {
              id: currentUser.id,
              username: currentUser.username,
              firstName: currentUser.firstName,
              lastName: currentUser.lastName,
              name: getName(currentUser),
              intials: getIntials(currentUser),
              image: currentUser.profile.image,
              access: this.props.defaultRole,
              temporaryDate: "",
              datePicker: false,
              disable: true,
              arrowDown: true,
            },
          ]
        : shareItem.createdBy.id === currentUser.id
        ? [
            {
              id: shareItem.createdBy.id,
              username: shareItem.createdBy.username,
              firstName: shareItem.createdBy.firstName,
              lastName: shareItem.createdBy.lastName,
              name: getName(shareItem.createdBy),
              intials: getIntials(shareItem.createdBy),
              image: shareItem.createdBy.profile.image,
              access: "Owner",
              temporaryDate: "",
              datePicker: false,
              disable: true,
              arrowDown: true,
            },
          ]
        : [
            {
              id: shareItem.createdBy.id,
              username: shareItem.createdBy.username,
              firstName: shareItem.createdBy.firstName,
              lastName: shareItem.createdBy.lastName,
              name: getName(shareItem.createdBy),
              intials: getIntials(shareItem.createdBy),
              image: shareItem.createdBy.profile.image,
              access: "Owner",
              temporaryDate: "",
              datePicker: false,
              disable: true,
              arrowDown: true,
            },
            {
              id: currentUser.id,
              username: currentUser.username,
              firstName: currentUser.firstName,
              lastName: currentUser.lastName,
              name: getName(currentUser),
              intials: getIntials(currentUser),
              image: currentUser.profile.image,
              access: this.props.defaultRole,
              temporaryDate: "",
              datePicker: false,
              disable: true,
              arrowDown: true,
            },
          ];
      const accessUsers = [...arrObj, ...this.props.accessUsers];
      this.props.setAccessUsers(accessUsers);
    }
  }

  sortButton = (userId) =>
    React.forwardRef(({ onClick }, ref) =>
      this.props.accessUsers.map((accessUser) => {
        return (
          accessUser.id === userId && (
            <button
              className="btn-dropdown btn-sort access-btn"
              disabled={accessUser.disable}
              ref={ref}
              onClick={(e) => {
                e.preventDefault();
                // accessUser.arrowDown = !accessUser.arrowDown;
                onClick(e);
              }}
            >
              <div className="size-h5">{accessUser.access}</div>
              <img
                className={`ml-2 mr-0 ${
                  accessUser.disable ? "img-disable" : ""
                }`}
                width="12"
                height="12"
                src={accessUser.arrowDown ? ArrowDown : ArrowUp}
                alt={accessUser.arrowDown ? "arrowDown" : "arrowUp"}
              />
            </button>
          )
        );
      })
    );

  searchUsers = (e) => {
    const val = e.target.value.trim();
    if (val === "") {
      this.setState({
        shareUser: val,
        showDropDown: false,
      });

      return;
    }
    this.setState({ shareUser: val });
    const variables = {
      name: val,
    };

    apolloClient
      .query({
        query: gql`
          query userSearch($name: String!) {
            userSearch(name: $name) {
              id
              username
              firstName
              lastName
              email
              profile {
                id
                image
                role {
                  id
                  name
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let filteredUsers = [];
        result.data.userSearch.map((user) => {
          if (!this.props.accessUsers.find((usr) => usr.id === user.id)) {
            filteredUsers.push({
              ...user,
              name: getName(user),
              intials: getIntials(user),
              image: user.profile.image,
            });
          }
          return true;
        });
        this.setState({
          showDropDown: true,
        });
        this.props.setFilteredUsers(filteredUsers);
      })
      .catch((e) => {
        this.setState({ isLoading: false });     
      });
  };

  accessToUser = (user) => {
    let contains;
    this.props.accessUsers.map((accessUser) => {
      if (accessUser.id === user.id) {
        contains = true;
        this.setState({ showDropDown: false });
      }
      return true;
    });
    if (!contains) {
      user["access"] =
        this.props.defaultRole === "Owner" || this.props.defaultRole === ""
          ? "Owner"
          : this.props.defaultRole;
      user["temporaryDate"] = "";
      user["datePicker"] = false;
      user["disable"] = false;
      user["arrowDown"] = true;
      user["image"] = user.profile.image;
      user["intials"] = getIntials(user);
      // user["profile"] = user.profile;
      this.setState({
        shareUser: "",
        showDropDown: false,
      });
      this.props.setAccessUsers([...this.props.accessUsers, user]);
    }
  };

  handleAccess = (user, id) => {
    this.props.accessUsers.map((accessUser) => {
      if (user.id === accessUser.id) {
        this.props.folderAccess.map((faKey) => {
          if (faKey.id === id) {
            if (faKey.access === "Temporary User") {
              this.setState({ showDatePiker: true });
              accessUser.datePicker = true;
            } else {
              this.setState({ showDatePiker: false });
              accessUser.datePicker = false;
              accessUser.arrowDown = true;
              accessUser.temporaryDate = "";
            }
            accessUser.access = faKey.access;
          }
          return true;
        });
      }
      return true;
    });
  };

  getMinDate = () => {
    let date = new Date();
    date.setDate(date.getDate() + 1);
    return new Date(date);
  };

  handleDateChange = (val, user) => {
    const date = dateFormat(val, "mmm dd, yyyy");
    this.props.accessUsers.map((accessUser) => {
      if (accessUser.id === user.id) {
        accessUser.temporaryDate = date;
      }
      accessUser.datePicker = false;
      accessUser.arrowDown = true;
      return true;
    });
    this.setState({ showDatePiker: false });
  };

  deleteUser = (user) => {
    const findUser = this.props.accessUsers.findIndex(
      (accessUser) => accessUser.id === user.id
    );

    let filterArray = this.props.accessUsers.filter((accessUser, index) => {
      return index !== findUser;
    });
    this.props.setAccessUsers(filterArray);
  };

  componentWillUnmount() {
    document.removeEventListener(
      "mousedown",
      this.handleClickOutsideOfUserSearch
    );
  }

  handleClickOutsideOfUserSearch(event) {
    if (
      this.userSearchDropdownRef &&
      this.userSearchDropdownRef.current &&
      !this.userSearchDropdownRef.current.contains(event.target)
    ) {
      this.setState({ showDropDown: false, shareUser: "" });
    }
  }

  render() {
    return (
      <div className={this.props.colClass}>
        <div className="row">
          <h6>
            <strong>Shared With</strong>
          </h6>
        </div>
        <div className="row mt-1 serach-parent">
          <input
            type="text"
            maxLength="50"
            placeholder="&#xF002; Search"
            className="search-placeholder set-width"
            value={this.state.shareUser}
            onChange={this.searchUsers}
          />
          {this.state.showDropDown ? (
            <div
              className={`search-dropdown ${
                this.props.type ? "sharePopup" : ""
              }`}
              ref={this.userSearchDropdownRef}
            >
              {this.props.filteredUsers.length > 0 ? (
                this.props.filteredUsers.map((filterUser, index) => {
                  return (
                    <div
                      className={`search-dropdown-row ${
                        this.props.filteredUsers.length - 1 !== index
                          ? "add-shadow"
                          : ""
                      }`}
                      key={index}
                      onClick={() => this.accessToUser(filterUser)}
                    >
                      <ProfileWithName
                        sKey={filterUser.id}
                        nameIntial={filterUser.intials}
                        personName={filterUser.name}
                        profile={filterUser.image}
                        isPopover={isPopover}
                      />
                    </div>
                  );
                })
              ) : (
                <p className="text-center mb-0">No matched result found.</p>
              )}
            </div>
          ) : null}
        </div>
        <div className="row create-folder-header pb-3 mt-6">
          {heading.map((hKey, index) => (
            <div className={index === 0 ? "col-md-4" : "col-md-8"} key={hKey}>
              <label>{hKey}</label>
            </div>
          ))}
        </div>
        {this.props.accessUsers.map((uKey, index) => (
          <div className="row create-folder-row" key={index}>
            <div className="col-md-4">
              <ProfileWithName
                sKey={uKey.id}
                nameIntial={uKey.intials}
                personName={uKey.name}
                profile={uKey.image}
                isPopover={isPopover}
              />
            </div>
            <div className="col-md-8">
              <div className="access-row">
                <Dropdown alignCenter>
                  <Dropdown.Toggle
                    as={this.sortButton(uKey.id)}
                  ></Dropdown.Toggle>
                  <Dropdown.Menu>
                    {this.props.folderAccess.map((faKey) => (
                      <>
                        <Dropdown.Item
                          as="a"
                          key={faKey.id}
                          value={faKey.access}
                          onClick={(e) => {
                            this.handleAccess(uKey, faKey.id);
                          }}
                        >
                          {faKey.access}
                        </Dropdown.Item>
                      </>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                {uKey.datePicker && this.state.showDatePiker && (
                  <div className="date-picker">
                    <Calendar
                      date={this.state.selectedDate}
                      minDate={this.getMinDate()}
                      onChange={(val) => this.handleDateChange(val, uKey)}
                    />
                  </div>
                )}
                <div className="date-val">{uKey.temporaryDate}</div>
                <img
                  className={[
                    "close-icon",
                    uKey.disable ? "img-disable" : "",
                  ].join(" ")}
                  src={CloseIcon}
                  alt="closeIcon"
                  style={{ alignSelf: "center" }}
                  onClick={() => this.deleteUser(uKey)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default ShareWith;
